import { z } from 'zod';
// Spelled out rather than `/^[a-f\d]{24}$/i`: z.toJSONSchema drops regex flags,
// so the `i` form renders as a lowercase-only `pattern` wherever a schema built
// on this is shown to a model. Both forms accept the same strings.
export const OBJECT_ID_RE = /^[0-9a-fA-F]{24}$/;
/** Validates a MongoDB ObjectId: 24-character hexadecimal string */ export const ObjectIdSchema = z.string().regex(OBJECT_ID_RE, 'Invalid ObjectId');

//# sourceMappingURL=object-id.schema.js.map